<template lang='pug'>
div(:class='$style[`cc-education-bar`]')
  div(:class='$style[`cc-education-bar-wrap`]')
    router-link.font-medium(
      :class='$style[`cc-education-bar-nav`]'
      :active-class='$style[`js-selected`]'
      tabindex='0'
      aria-label='前往線上課程'
      to='/course')
      span 線上課程

    //- router-link.font-medium(
    //-   :class='$style[`cc-education-bar-nav`]'
    //-   :active-class='$style[`js-selected`]'
    //-   tabindex='0'
    //-   aria-label='QA問答庫'
    //-   to='/aidoctor')
    //-   span QA問答庫

    router-link.font-medium(
      :class='$style[`cc-education-bar-nav`]'
      :active-class='$style[`js-selected`]'
      tabindex='0'
      aria-label='講座活動'
      to='/events')
      span 講座活動

</template>

<script>
// import { mapActions, mapMutations, mapGetters } from 'vuex';
// import IconCure from '../icon/Cure';
// import IconDialog from '../icon/Dialog';
// import IconConsultant from '../icon/Consultant';

export default {
  // components: {
  //   IconCure,
  //   IconDialog,
  //   IconConsultant
  // },

  // data() {
  //   return {
  //   };
  // },

  // methods: {
  // },

  // eslint-disable-next-line vue/order-in-components
  // watch: {
  // },
};

</script>

<style module lang='scss'>
  @import '../../sass/component/page/educationBar.scss';
</style>
